import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiPopover } from '@taiga-ui/cdk';
import { TuiDialogCloseService } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

import { SidePageCloseService } from './sidepage-close.service';
import { SidePageOptions } from './sidepage-options';

@Component({
  selector: 'app-sidepage',
  templateUrl: './sidepage.template.html',
  styleUrls: ['./sidepage.style.less'],
  host: {
    '[style.justify-content]': "context['justify-content']",
  },
  providers: [TuiDialogCloseService],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SidePageComponent {
  protected readonly context = inject<TuiPopover<SidePageOptions, boolean>>(POLYMORPHEUS_CONTEXT);
  private readonly closer = inject(SidePageCloseService);

  protected close(): void {
    this.closer.requestClose(this.context);
  }
}
